import moment from 'moment'
import { GraphType } from '../constants'

export function retry(fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error)
            return
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject)
        }, interval)
      })
  })
}

export const numDifferentiation = (val) => {
  if (val === undefined || val === null) return null
  if (val >= 10000000) val = parseFloat((val / 10000000).toFixed(2)) + ' Cr'
  else if (val >= 100000) val = parseFloat((val / 100000).toFixed(2)) + ' Lac'
  else if (val >= 1000) val = parseFloat((val / 1000).toFixed(2)) + ' K'
  return val < 10 ? '0' + val.toString() : val.toString()
}

export const getGraphStartEndTime = (graphType) => {
  if (graphType === GraphType.DAY) {
    return {
      start: moment().subtract(12, 'days').startOf('day').unix(),
      end: moment().endOf('day').unix(),
    }
  } else if (graphType === GraphType.WEEK) {
    return {
      start: moment().subtract(12, 'weeks').startOf('week').unix(),
      end: moment().endOf('week').unix(),
    }
  } else if (graphType === GraphType.MONTH) {
    return {
      start: moment().subtract(12, 'months').startOf('month').unix(),
      end: moment().endOf('month').unix(),
    }
  } else if (graphType === GraphType.QUARTER) {
    return {
      start: moment('2023-10-01', 'YYYY-MM-DD').startOf('quarter').unix(),
      end: moment().endOf('quarter').unix(),
    }
  } else if (graphType === GraphType.YEAR) {
    return {
      start: moment('2023-10-01', 'YYYY-MM-DD').startOf('year').unix(),
      end: moment().endOf('year').unix(),
    }
  }
}

export const getGraphStartEndTimeForDateRange = (values) => {
  const start = values?.[0]
    ? moment(values[0]).startOf('day').unix()
    : moment().subtract(11, 'months').startOf('month').unix()

  const end = values?.[1]
    ? moment(values[1]).endOf('day').unix()
    : moment().endOf('day').unix()

  const diff = moment.unix(end).diff(moment.unix(start), 'days')
  console.log({ diff })

  if (diff < 12) {
    return { start, end, graphType: GraphType.DAY }
  } else if (diff < 84) {
    return { start, end, graphType: GraphType.WEEK }
  } else if (diff < 365) {
    return { start, end, graphType: GraphType.MONTH }
  } else {
    return { start, end, graphType: GraphType.YEAR }
  }
}
